module.exports = __webpack_public_path__ + "static/media/hovering-and-pinning.7898c731.gif";